<template>
    <div>
        <div class="container">
             <div class="row">
                 <div class="col-xl-8 bg-white header-materia mb-xl-4 mb-3 pt-4 pt-xl-0">
                     <div class="text-left ml-xl-0 pl-xl-2 mt-4 pt-2">
                         <h1 class="font-56 font-glacial-bold">{{data.titulo}}</h1>
                     </div>
                 </div>
             </div>
            <div class="row pb-xl-4 mb-1">
                <div class="col-xl-12 mb-3 pb-md-3">
                    <div class="row">
                        <div class="col-12 col-md-7">
                            <div class="d-flex justify-content-center align-items-center image-university-unifran background-image" :style="`background-image: url(${data.imagem.url})`">
                                <b-modal 
                                    @show="play = true" @hide="play = false" ref="modal" body-class="p-0" size="lg" hide-footer hide-header centered title="Using Component Methods">
                                </b-modal>
                            </div>
                        </div>
                        <div class="col-12 col-md-5 mt-4 mt-md-0">
                            <div class="text-sm-left text-center">
                                <h4 class="font-regular">{{data.subtitulo}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 pb-3">
                    <div class="font-regular font-18 text-xl-left text-center" v-html="data.mensagem">
                    </div>
                </div>
            </div>
            <div class="row justify-content-center pb-xl-5 pb-4 mb-md-5 mb-0">
                <div class="col-xl-12">
                    <div class="d-flex justify-content-center">
                        <div>
                            <a v-bind:href="'https://'+data.link" target="_blank">
                                <b-btn class="btn btn-conheca-cursos btn-pointer btn-opacidade"></b-btn>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        data : null,
    }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/unifran.vue